/**
 * Electrosmith — Volume Pricing Price Display
 * 
 * Watches the quantity input on product pages and updates the displayed
 * price to show a strikethrough base price + discounted price when the
 * quantity falls within a configured tier.
 *
 * HOW TO INSTALL:
 * 1. Shopify Admin → Online Store → Themes → your Dawn theme → Edit code
 * 2. Open sections/main-product.liquid
 * 3. Scroll to the very bottom and paste this entire script block before </section>
 *
 * ALTERNATIVELY (cleaner):
 * 1. Create a new file in assets/ called electrosmith-volume-pricing.js
 *    and paste everything inside the <script> tags below (without the tags).
 * 2. In sections/main-product.liquid, near the bottom add:
 *    <script src="{{ 'electrosmith-volume-pricing.js' | asset_url }}" defer></script>
 */

(function () {

  // ---------------------------------------------------------------------------
  // TIER CONFIGURATION
  // To update prices, edit only this section.
  // Each product is keyed by its Shopify handle (the slug in the product URL).
  // ---------------------------------------------------------------------------
  const VOLUME_PRICING = {
    'daisy-seed': {
      basePrice: 29.99,
      tiers: [
        { min: 100, max: 299,      price: 28.49 },
        { min: 300, max: 499,      price: 26.99 },
        { min: 500, max: 999,      price: 25.49 },
        { min: 1000, max: Infinity, price: 23.99 },
      ]
    },
    'daisy-seed2-dfm': {
      basePrice: 29.99,
      tiers: [
        { min: 100, max: 299,      price: 28.49 },
        { min: 300, max: 499,      price: 26.99 },
        { min: 500, max: 999,      price: 25.49 },
        { min: 1000, max: Infinity, price: 23.99 },
      ]
    },
    'patch-submodule': {
      basePrice: 34.99,
      tiers: [
        { min: 100, max: 299,      price: 33.32 },
        { min: 300, max: 499,      price: 31.65 },
        { min: 500, max: Infinity,  price: 29.99 },
      ]
    },
  };

  // ---------------------------------------------------------------------------
  // HELPERS
  // ---------------------------------------------------------------------------
  function formatMoney(amount) {
    return '$' + amount.toFixed(2);
  }

  function getProductHandle() {
    // Shopify exposes this globally on product pages
    return (window.ShopifyAnalytics &&
            window.ShopifyAnalytics.meta &&
            window.ShopifyAnalytics.meta.product &&
            window.ShopifyAnalytics.meta.product.handle) ||
           document.documentElement.dataset.handle || // some themes set this
           null;
  }

  function getTierForQty(tiers, qty) {
    for (const tier of tiers) {
      if (qty >= tier.min && qty <= tier.max) return tier;
    }
    return null;
  }

  // ---------------------------------------------------------------------------
  // PRICE DISPLAY
  // Dawn renders the regular price inside:
  //   .price__regular > .price-item--regular
  // When on sale it switches to .price__sale — we leave that untouched
  // and only operate on .price__regular.
  // ---------------------------------------------------------------------------
  function renderPrice(priceContainer, basePrice, discountedPrice) {
    // Find or create our custom wrapper inside the price container
    let wrapper = priceContainer.querySelector('#es-volume-price');

    if (discountedPrice !== null && discountedPrice < basePrice) {
      // Show slashed base + highlighted discounted price
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.id = 'es-volume-price';
        wrapper.style.cssText = 'display:flex; align-items:baseline; gap:8px; flex-wrap:wrap;';
        priceContainer.appendChild(wrapper);
      }
      wrapper.innerHTML = `
        <s class="price-item" style="color: var(--color-foreground); opacity: 0.45; font-size: 1em;">
          ${formatMoney(basePrice)}
        </s>
        <span class="price-item price-item--sale" style="color: rgb(var(--color-button)); font-weight: 700;">
          ${formatMoney(discountedPrice)}
        </span>
        <span style="font-size: 0.75em; opacity: 0.65; align-self: center;"></span>
      `;
      // Hide Dawn's own price text so we don't double-display
      const originalPriceItem = priceContainer.querySelector('.price-item--regular:not(#es-volume-price *)');
      if (originalPriceItem) originalPriceItem.style.display = 'none';

    } else {
      // Restore original price display
      if (wrapper) wrapper.remove();
      const originalPriceItem = priceContainer.querySelector('.price-item--regular');
      if (originalPriceItem) originalPriceItem.style.display = '';
    }
  }

  // ---------------------------------------------------------------------------
  // INIT
  // ---------------------------------------------------------------------------
  function init() {
    const handle = getProductHandle();
    if (!handle || !VOLUME_PRICING[handle]) return; // Not a configured product

    const config = VOLUME_PRICING[handle];

    // Dawn's quantity input
    const qtyInput = document.querySelector('input[name="quantity"]');
    // Dawn's price container (wraps both regular and sale states)
    const priceContainer = document.querySelector('.price__regular');

    if (!qtyInput || !priceContainer) return;

    function update() {
      const qty = parseInt(qtyInput.value, 10) || 1;
      const tier = getTierForQty(config.tiers, qty);
      renderPrice(priceContainer, config.basePrice, tier ? tier.price : null);
    }

    qtyInput.addEventListener('change', update);
    qtyInput.addEventListener('input', update);

    // Run once on load in case a qty > 1 is pre-filled
    update();
  }

  // Wait for DOM — defer attribute usually handles this, but belt-and-suspenders
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();